export default __webpack_public_path__ + "static/media/3132 spice rack E side.12575727.png";